export default "__VITE_ASSET__Db6s9Imw__"